import { Category } from "@forcode/domain";
import { Typography } from "../../atom";
import css from "./CategoryHeader.module.css";

export interface ICategoryHeaderProps {
  category: Category;
}

const BASE_CLASS = "f-OrganismCategoryHeader";

export const CategoryHeader = ({ category }: ICategoryHeaderProps) => {
  const { name } = category;

  return (
    <header className={css[BASE_CLASS]}>
      <Typography as="span" className={css[`${BASE_CLASS}-subTitle`]}>
        Todos los artículos de la categoría
      </Typography>
      <Typography as="h2" className={css[`${BASE_CLASS}-title`]}>
        {name}
      </Typography>
    </header>
  );
};
